import React, {createContext, useContext, useState} from 'react';
import Content from "./Content/Content.tsx";
import MetadataContent from "./Content/Metadata/Metadata.tsx";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import MessageBottomContainer from "./MessageBottomContainer/MessageBottomContainer.tsx";
import Flag from "./MessageBottomContainer/Shared/Icons/Flag.tsx";
import {toggleMessageImportance} from "../../../Utils/messageObject/messageObjectUtils.ts";
import {GlobalContext} from "../../../App.tsx";
import UnreviewedFiles from "./UnreviewedFiles/UnreviewedFiles.tsx";

export const MessageContext = createContext({
    isPreview: null as any | null
});

export const MessageBottomContainerContext = createContext({
    group: null as any | null, editedContent: null as any | null,
    setEditedContent: null as any | null, isLast: null as any | null
});

interface MessageProps {
    group: any;
    isPreview: boolean;
    isLast: boolean;
}

const Message: React.FC<MessageProps> = ({ group, isPreview, isLast }) => {
    const { setMessages } = useContext(GlobalContext);
    const [editedContent, setEditedContent] = useState<any[]>([]);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { editingId, importantMessageIds, conversationId, unreviewedFileTracker } = dynamicStateObj;
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { isIncognito } = settingsObj;
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const updateImportantMessageIds = useAppStore((state: any) => state.updateImportantMessageIds);
    const messageId = group.messages[0].id;

    const getContentContainerMode = () => {
        if (group.groupRole === "assistant") {
            return `flex-1 min-w-0 ${importantMessageIds.has(messageId) ? "max-w-[90%]" : ""}`;
        } else {
            return "max-w-3/4 ml-auto";
        }
    }
    const getContentInnerContainerMode = () => {
        if (group.groupRole === "assistant") {
            return "max-w-full relative ";
        } else {
            return "max-w-full flex";
        }
    }
    const contentInnerContainerMode = getContentInnerContainerMode();
    const contentContainerMode = getContentContainerMode();

    return (
        <MessageContext.Provider value={{ isPreview }}>
            <div className={"pb-4 max-w-4xl mx-auto"}>
                {group.groupRole === "user" && (
                    <div className={`flex justify-center mx-auto`}>
                        <MetadataContent group={group}/>
                    </div>
                )}
                <div
                    className={`flex mb-2.5 ${group.groupRole === 'assistant' ? `items-start px-1.5 max-w-[99%]` : 'justify-end mr-2'}`}
                >
                    <div className={`flex flex-col ${contentContainerMode} text-black dark:text-neutral-100`}>
                        <div className={`flex ${group.groupRole === 'assistant' ? 'relative' : 'justify-end'}`}>
                            <div className={`${contentInnerContainerMode} relative`}>
                                {importantMessageIds.has(messageId) && !isPreview && (
                                    <div
                                        className={`absolute bottom-2 ${group.groupRole === "user" ? "-left-7" : "-right-7"} cursor-pointer`}
                                        onClick={() => toggleMessageImportance(user, isIncognito, conversationId, messageId, !importantMessageIds.has(messageId), updateImportantMessageIds, setMessages)}
                                        data-tooltip-id="main-tooltip"
                                        data-tooltip-content="Unmark message as important"
                                        data-tooltip-place={`${group.groupRole === "user" ? "left" : "right"}`}
                                    >
                                        <Flag color="yellow" />
                                    </div>
                                )}
                                <Content
                                    group={group}
                                    editedContent={editedContent}
                                    setEditedContent={setEditedContent}
                                    editingId={editingId}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {isLast && group.groupRole === "assistant" && Object.keys(unreviewedFileTracker).length !== 0 && (
                    <UnreviewedFiles />
                )}
                <MessageBottomContainerContext.Provider value={{ group, editedContent, setEditedContent, isLast }}>
                    <MessageBottomContainer/>
                </MessageBottomContainerContext.Provider>
            </div>
        </MessageContext.Provider>
    );
};

export default Message;